<div class="scrollingcontainer"><app-full-logo></app-full-logo>
    <app-fancy-page-title topTitle="AMERICAN EXPLORER" subTitle="All Ship Access"></app-fancy-page-title>
    <!-- <app-fancy-page-title topTitle="WELCOME ABOARD" subTitle="American Explorer"></app-fancy-page-title> -->
    <div class="goldbar d-flex justify-content-center">_________</div>
    <div class="logininstructionarea">
        <div class="logininstruction d-flex justify-content-center">Please Select a Ship</div>
        <div class="logininstruction d-flex justify-content-center">Then Click Access American Explorer</div>
    </div>

    <div class="center"><app-ship-dropdown-list></app-ship-dropdown-list></div>